import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmModal} from 'components/modals';
import {TRANSLATION_KEYS} from 'locale';
import {dataUtils} from 'utils';

import {RouteLeavingGuard} from '../RouteLeavingGuard';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.UNSAVED_CHANGES_LEAVE_PROMPT;

type Props = {
    values: any;
    initialValues: any;
}

export const UnsavedChangesLeavePrompt: React.FC<Props> = ({values, initialValues}: Props) => {
    const {t} = useTranslation();
    const when = useMemo(() => !dataUtils.isEqualValues(values, initialValues), [values, initialValues]);
    return (
        <RouteLeavingGuard when={when}>
            {({open, onClose}) => (
                <ConfirmModal
                    open={open}
                    fullWidth
                    maxWidth='sm'
                    title={t(T_KEYS.TITLE)}
                    content={t(T_KEYS.CONTENT)}
                    okText={t(T_KEYS.OK_BTN)}
                    onClose={onClose}
                />
            )}
        </RouteLeavingGuard>
    );
};
